import type { ISODate, IntakeId } from './types'

/**
 * The plan, per target intake.
 *
 * Written out explicitly rather than derived by arithmetic: there are only two,
 * and the audition round has to land on one of the Conservatorium's actual
 * rounds (November / February / July), which no offset formula would respect.
 *
 * These are *planning targets* built backwards from the intake month using the
 * pathway guide's own sequencing. They are not published deadlines — confirm
 * every one with the institution.
 */
export interface IntakePlan {
  /** Documents translated, English test sat, repertoire chosen. */
  docsReady: ISODate
  /** Applications submitted and the audition round registered. */
  applyBy: ISODate
  /** The Conservatorium round being targeted. */
  auditionRound: ISODate
  /** Student visa (subclass 500) lodged — allow several months. */
  visaLodge: ISODate
  flights: ISODate
  orientation: ISODate
}

export const INTAKE_PLANS: Record<IntakeId, IntakePlan> = {
  // Second intake of 2027. Targets the February 2027 audition round, which
  // leaves six months between result and start.
  aug2027: {
    docsReady: '2026-12-15',
    applyBy: '2027-01-15',
    auditionRound: '2027-02-15',
    visaLodge: '2027-05-14',
    flights: '2027-07-01',
    orientation: '2027-07-26',
  },
  // February 2028. Targets the November 2027 round.
  feb2028: {
    docsReady: '2027-06-30',
    applyBy: '2027-08-16',
    auditionRound: '2027-11-15',
    visaLodge: '2027-11-30',
    flights: '2028-01-14',
    orientation: '2028-02-14',
  },
}
